module.exports = __webpack_public_path__ + "static/media/rings-wedding.a598d1dc.svg";